// extracted by mini-css-extract-plugin
export default {"scheduled":"PushNotificationsTable_scheduled_ZUBEr","actions":"PushNotificationsTable_actions_bfsV8"};